require('./_textblock');
require('./_customtext');
require('./_manualCancel');
$(document).ready(function () {
    // https://tc39.github.io/ecma262/#sec-array.prototype.find
    if (!Array.prototype.find) {
        Object.defineProperty(Array.prototype, 'find', {
        value: function(predicate) {
            // 1. Let O be ? ToObject(this value).
            if (this == null) {
            throw TypeError('"this" is null or not defined');
            }

            var o = Object(this);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;

            // 3. If IsCallable(predicate) is false, throw a TypeError exception.
            if (typeof predicate !== 'function') {
            throw TypeError('predicate must be a function');
            }

            // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
            var thisArg = arguments[1];

            // 5. Let k be 0.
            var k = 0;

            // 6. Repeat, while k < len
            while (k < len) {
            // a. Let Pk be ! ToString(k).
            // b. Let kValue be ? Get(O, Pk).
            // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
            // d. If testResult is true, return kValue.
            var kValue = o[k];
            if (predicate.call(thisArg, kValue, k, o)) {
                return kValue;
            }
            // e. Increase k by 1.
            k++;
            }

            // 7. Return undefined.
            return undefined;
        },
        configurable: true,
        writable: true
        });
    }

    var curLang = 'de';
    if ($('body').hasClass('lang-fr')) {
        curLang = 'fr';
    }

    var lang = {
        search: "Suche",
        noResults: "Keine Suchergebnisse",
        noData: "Keine Daten vorhanden"
    };

    if (curLang == 'fr') {
        lang = {
            search: "Recherche",
            noResults: "Aucun résultat de recherche",
            noData: "Pas de données disponibles"
        };
    }

    // this makes sure the upgrade notice is displayed
    // document.body.classList.add("show-ie-note");

    $('.init-datatable').DataTable({
        // serverSide: true
        // stateSave: true,
        responsive: true,
        pagingType: 'numbers',
        searching: true,
        info: false,
        lengthChange: false,
        language: {
            "search": lang.search,
            "zeroRecords": lang.noResults,
            "emptyTable": lang.noData,
        },
        columnDefs: [
            {
                "targets": 'no-sort',
                "orderable": false
            },
            {
                "targets": "no-search",
                "searchable": false
            }
        ],
        "fnDrawCallback": function (oSettings) {
            if (oSettings._iDisplayLength > oSettings.fnRecordsDisplay()) {
                $(oSettings.nTableWrapper).find('.dataTables_paginate').hide();
            }
        }
    });

    var nonce = $('body').data('rest-nonce');
    $('.js-select2').select2();

    $('.input-daterange').datepicker({
        format: "dd.mm.yyyy",
        weekStart: 1,
        todayBtn: true,
        // language: "de", // fill with data-attribut in hbs
        orientation: "bottom left",
        daysOfWeekHighlighted: "0,6",
        todayHighlight: true
    });

    $('[data-show-filter-area]').on('click', function(event) {
        event.preventDefault();
        var filter = $(this).data('show-filter-area');
        $(this).toggleClass('showing');
        $('[data-filter-target="' + filter + '"]').toggleClass('show');
    })

    $("[data-show-filter]").on('change', function () {
        var filter = $(this).data('show-filter');
        var ifArray = $(this).data('show-filter-if').split(",");
        var url = $(this).data('show-url');
        var sData = $(this).select2('data');
        var obj = sData.find(function(o){ return $.inArray(o.id, ifArray) != -1;});

        if (obj && obj !== undefined) {
            url = url.replace("#id#", obj.id);
            $.ajax({
                type: 'GET',
                url: url,
                beforeSend: function (xhr) {
                    if (nonce && nonce.length) {
                        xhr.setRequestHeader('X-WP-Nonce', nonce);
                    }
                }
            })
            .done(function (result) {
                var focus = $('[data-filter-target="' + filter + '"] select');
                focus.empty();

                var add = '<option value="0">'+focus.data('all')+'</option>';
                focus.append(add);
                for (let i = 0; i < result.length; i++) {
                    const element = result[i];
                    var option = '<option value="'+element.id+'">'+element.text+'</option>';
                    focus.append(option);
                }
                $('[data-filter-target="' + filter + '"]').addClass('show');
            })
            .fail(function (result) {
                console.warn(result);
            });
        } else {
            $('[data-filter-target="' + filter + '"]').removeClass('show');
            $('[data-filter-target="' + filter + '"] select').empty().val("-1");
        }
    });

    $('[data-filter-reset]').on('click', function(event) {
        event.preventDefault();
        var parent = $(this).closest('[data-rest]');
        parent.find('[data-show-filter-area].showing').removeClass('showing');
        parent.find('[data-filter-target].show').removeClass('show');
        parent.find('.rest-filter :input')
            .not(':button, :submit, :reset, :hidden')
            .val('')
            .prop('checked', false)
            .prop('selected', false)
            .trigger('change');

        parent.find('[data-filter-send]').trigger('click');
    });

    $('body').on('click', 'a[data-inactive], a[data-delete]', function (event) {

        event.preventDefault();
        var item = $(this);
        var error = $('[data-api-error]');
        var url = item.data('url');
        var id = item.closest('tr').data('id');
        var title = item.closest('tr').find('[data-title]').text();
        url = url.replace("#id#", id);

        $.confirm({
            title: item.data('fc-title'),
            content: item.data('fc-content').replace("#title#", title),
            buttons: {
                cancel: {
                    text: item.data('fc-no'),
                    btnClass: 'mxm_button btn btn-link'
                },
                confirm: {
                    text: item.data('fc-yes'),
                    btnClass: 'mxm_button btn btn-primary',
                    action: function (confirmBtn) {
                        $.dialog({
                            title: item.data('fc-title'),
                            content: item.data('fc-success'),
                            icon: 'fal fa-spinner fa-spin',
                        });
                        $.ajax({
                                type: 'GET',
                                url: url,
                                beforeSend: function (xhr) {
                                    if (nonce && nonce.length) {
                                        xhr.setRequestHeader('X-WP-Nonce', nonce);
                                    }
                                }
                            })
                            .done(function (result) {
                                error.addClass('d-none');
                                if (result) {
                                    window.location.reload();
                                } else {
                                    error.removeClass('d-none');
                                }
                            })
                            .fail(function (result) {
                                console.warn(result);
                                error.removeClass('d-none');
                            });
                    }
                }
            }
        });
    });


    $('body').on('click', 'a[data-copy]', function (event) {

        event.preventDefault();
        var item = $(this);
        var nonce = $('body').data('rest-nonce');
        var error = $('[data-api-error]');
        var url = item.data('url');
        var id = item.closest('tr').data('id');
        var title = item.closest('tr').find('[data-title]').text();
        url = url.replace("#id#", id);

        $.confirm({
            title: item.data('fc-title'),
            content: item.data('fc-content').replace("#title#", title) +
                '<form action="" class="formTitle mt-1">' +
                '<div class="form-group">' +
                '<input type="text" class="newtitle form-control" required />' +
                '</div>' +
                '</form>',
            buttons: {
                cancel: {
                    text: item.data('fc-no'),
                    btnClass: 'mxm_button btn btn-link'
                },
                confirm: {
                    text: item.data('fc-yes'),
                    btnClass: 'mxm_button btn btn-primary',
                    action: function (confirmBtn) {
                        var newtitle = this.$content.find('.newtitle').val();
                        if (!newtitle) {
                            $.alert('Eingabe ungültig');
                            return false;
                        }
                        $.dialog({
                            title: item.data('fc-title'),
                            content: item.data('fc-success'),
                            icon: 'fal fa-spinner fa-spin',
                        });
                        url = url.replace("#newtitle#", newtitle);
                        $.ajax({
                                type: 'GET',
                                url: url,
                                beforeSend: function (xhr) {
                                    if (nonce && nonce.length) {
                                        xhr.setRequestHeader('X-WP-Nonce', nonce);
                                    }
                                }
                            })
                            .done(function (result) {
                                error.addClass('d-none');
                                if (result) {
                                    window.location.href = result;
                                } else {
                                    error.removeClass('d-none');
                                }
                            })
                            .fail(function (result) {
                                console.warn(result);
                                error.removeClass('d-none');
                            });
                    },
                    onContentReady: function () {
                        var jc = this;
                        this.$content.find('form').on('submit', function (e) {
                            // if the user submits the form by pressing enter in the field.
                            e.preventDefault();
                            jc.$$formSubmit.trigger('click');
                        });
                    }
                }
            }
        });
    });

    $('[data-name="focus"] select').on("change", function (event) {
        var item = $(this);
        var focus = item.val();
        var pid = item.closest('[data-url]').data('pid');
        var nonce = $('body').data('rest-nonce');
        var url = item.closest('[data-url]').data('url');
        url = url.replace("#focus#", focus);
        url = url.replace("#pid#", pid);
        $.ajax({
            type: 'GET',
            url: url,
            beforeSend: function (xhr) {
                if (nonce && nonce.length) {
                    xhr.setRequestHeader('X-WP-Nonce', nonce);
                }
            }
        })
        .done(function (result) {
            if (result) {
                var $dropdown = $('[data-name="dauer"] select').empty();
                $dropdown.prop('disabled', true);
                $.each(result, function () {
                    $dropdown.append($("<option />").val(this.id).text(this.value));
                });
                $dropdown.prop('disabled', false);
            }
        })
        .fail(function (result) {
            console.warn(result);
        });
    });

    $("[data-filter]").keyup(function (event) {
        if (event.keyCode === 13) {
            $("[data-filter-send]").click();
        }
    });

    var requiredCvContainer = document.querySelector(".af-field-cv.af-field-required");

    if (requiredCvContainer) {
        var fileInput = requiredCvContainer.querySelector('input[type="file"]');

        if (fileInput) {
            fileInput.addEventListener('change', function(e) {
                var input = e.target;
                var hiddenField = document.querySelector('input[type="hidden"][name="cv-uploaded"]');

                if (hiddenField) {
                    if (input.files[0]) {
                        hiddenField.value = "1";
                    } else {
                        hiddenField.value = "0";
                    }
                }
            })
        }
    }
});
